import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {UserService} from "app/core/user/user.service";
import {ExtProfilesService} from "../../ext-profiles.service";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {IUser} from 'app/interfaces/IUser'
import {SurveyViewerService} from "../../../../survey/survey-viewer/services/survey-viewer.service";

@UntilDestroy()
@Component({
    selector: 'app-generic-multi',
    templateUrl: './generic-multi.component.html',
    styleUrls: ['./generic-multi.component.scss'],
    standalone: false
})
export class GenericMultiComponent implements OnInit {

  cUser: IUser;
  @Input() keyname: string;
  @Input() curLang: string;
  @Input() displayDebug: false;
  isMobile: boolean;

  public fGroup: UntypedFormGroup = new UntypedFormGroup({});

  constructor(
    private userService: UserService,
    public extProfilesService: ExtProfilesService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {

    const userAgent = window.navigator.userAgent.toLowerCase();
    this.isMobile = userAgent.includes('mobile');

    this.extProfilesService.getParams(this.keyname).forEach((aParam) => {
      this.fGroup.addControl(aParam.key, new UntypedFormControl(false));
    })

    this.userService.user$.pipe(untilDestroyed(this))
      .subscribe((aUser) => {
        this.cUser = aUser;

        const values: string[] = aUser.extProfiles?.[this.keyname]?.split(';').filter(value => value) || [];
        const toPatch = {};

        this.extProfilesService.getParams(this.keyname).forEach((aParam) => {
          toPatch[aParam.key] = values.includes(aParam.key);
        })

        this.fGroup.patchValue(toPatch, {emitEvent: false});

        if (!this.fGroup.pristine) {
          this.fGroup.setErrors({'atLeastOne': values.length === 0});
        }

        this.cdr.markForCheck();

      })

    this.fGroup.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      const result: Record<string, boolean> = this.fGroup.getRawValue();
      const onlyTrue = Object.keys(result).map((aKey) => {
        if (result[aKey]) {
          return aKey;
        }
      }).filter(item => item);
      this.extProfilesService.updateExtProfiles(this.keyname, onlyTrue.join(';'));
    });

  }

}
